/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ReactElement } from "react";
import { Fab, ThemeProvider } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import ZoomIn from "@material-ui/icons/ZoomIn";
import ZoomOut from "@material-ui/icons/ZoomOut";
import styled from "styled-components";

const ButtonContainer = styled.div`
  position: fixed;
  right: 30px;
  bottom: 30px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export interface Props {
  onZoomInClick: () => void;
  onZoomOutClick: () => void;
  showZoomIn: boolean;
  showZoomOut: boolean;
}

// TODO replace this implementation with Devine Elements once we have circular buttons
export default function ButtonsOverlay({
  onZoomInClick,
  onZoomOutClick,
  showZoomIn,
  showZoomOut,
}: Props): ReactElement {
  const theme = createMuiTheme({
    palette: {
      action: {
        active: "#87b9ff",
        disabledBackground: "#bdbdbd",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ButtonContainer>
        <Fab color="primary" disabled={!showZoomIn} onClick={onZoomInClick}>
          <ZoomIn />
        </Fab>

        <div style={{ height: 10 }} />

        <Fab color="primary" disabled={!showZoomOut} onClick={onZoomOutClick}>
          <ZoomOut />
        </Fab>
      </ButtonContainer>
    </ThemeProvider>
  );
}
